export const CHAR_DURATION = 0.3; // seconds per character (slowed down from 0.1)
export const CREDITS_ROLL_EASE = "linear";

// Calculate roll duration based on characters (0.3s per character)
export const calculateRollDuration = (credits: string[]): number => {
  const totalCharacters = credits.reduce((sum, credit) => sum + credit.length, 0);
  return totalCharacters * CHAR_DURATION;
};